import { styled } from "styled-components";

export const StyledGuestCounter = styled.div`
  color: ${({ theme }) => theme.colors.text};
  .counter-button {
    height: 32px;
    width: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 0.5px solid;
    background-color: transparent;
    img {
      filter: ${({ theme }) =>
        theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
    }
  }
`;
